import React from 'react';
import {minimumAmount,HIGH_MINIMUM_EUR} from '../lib/minimum.mjs';
export function MinimumInvestment({fund}) {
  const part=minimumAmount(fund),text=fund.minimum||fund.minimumNote||'Podatak još nije potvrđen';
  if(!part||part.amount<HIGH_MINIMUM_EUR)return <>{text}</>;
  return <>{text.slice(0,part.start)}<strong className="minimum-high">{text.slice(part.start,part.end)}</strong>{text.slice(part.end)}</>;
}
